import { X } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ComunidadLaunchModalProps {
  open: boolean;
  /** "Quiero saber más": el caller descarta el aviso y lleva a Comunidad resaltando Formaciones. */
  onLearnMore: () => void;
  /** X / Escape: descarta el aviso para siempre, sin navegar. */
  onClose: () => void;
  /** "Recordarme más tarde": el aviso vuelve a salir en unas horas. */
  onSnooze: () => void;
}

/**
 * Pop-up único de lanzamiento de la pestaña Comunidad ("Novedad: Comunidad"). Puramente
 * presentacional: el estado (descartado / pospuesto) y su persistencia viven en
 * `useComunidadLaunch`, y se monta una sola vez en `AppShell`.
 */
export function ComunidadLaunchModal({ open, onLearnMore, onClose, onSnooze }: ComunidadLaunchModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent
        style={{ maxWidth: '520px', padding: '2rem' }}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <button
          type="button"
          aria-label="Cerrar"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
        >
          <X size={18} />
        </button>
        <DialogHeader>
          <DialogTitle>Novedad: Comunidad</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm leading-relaxed text-gray-600">
          <p>
            Estamos felices de contarles que estrenamos una sección nueva dentro de la plataforma,
            llamada <strong className="font-semibold text-gray-800">Comunidad</strong>: un espacio
            para sentirnos parte de algo más grande.
          </p>
          <p>
            ✨ Junto con este lanzamiento, iniciamos el{' '}
            <strong className="font-semibold text-gray-800">Ciclo de Formaciones Internas</strong>.{' '}
            <u>La primera es en Octubre</u>, anotate ya! ✨
          </p>
          <div className="flex flex-col gap-2 pt-2">
            <Button onClick={onLearnMore} className="w-full">Quiero saber más</Button>
            <Button variant="ghost" onClick={onSnooze} className="w-full">Recordarme más tarde</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
